import { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import colors from '@legacy/moon/particles/colors';

const iconFill = Object.freeze({
  light: colors.darkside,
  dark: colors.silver,
  alpha: colors.silver,
});

const RightArrow = (props: Record<string, unknown>): JSX.Element => {
  // @ts-ignore
  const { product }: BitsoGlobals.LegacyTheme = useContext(ThemeContext);

  const fill = iconFill[product] || colors.silver;

  return (
    <svg width="39" height="10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.853.146a.5.5 0 01.707 0l3.944 3.943a1 1 0 010 1.415L34.56 9.447a.5.5 0 11-.707-.707l3.59-3.59a.5.5 0 000-.707l-3.59-3.59a.5.5 0 010-.707zM0 4.793a.5.5 0 01.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm6 0a.5.5 0 01.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm6.5-.5a.5.5 0 000 1h4a.5.5 0 000-1h-4zm5.5.5a.5.5 0 01.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5zm6.5-.5a.5.5 0 000 1h4a.5.5 0 000-1h-4zm5.5.5a.5.5 0 01.5-.5h4a.5.5 0 010 1h-4a.5.5 0 01-.5-.5z"
        fill={fill}
      />
    </svg>
  );
};

export default RightArrow;
